<template>
	<v-sheet color="transparent">
		<v-window v-model="window">
			<v-window-item value="intro">
				<render-content
					:id="survey.introduction"
					class="mb-5"
				></render-content>
			</v-window-item>
			<v-window-item
				v-for="question in visibleQuestions"
				:key="question"
				:value="question"
			>
				<questions
					:ids="[question]"
					v-model="data"
					@error="error = true"
				></questions>
			</v-window-item>
		</v-window>
		<mobile-controls
			v-model="window"
			:data="data"
			:context="windowOrder"
			v-if="!disable"
			:missing-contact-details="missingContactDetails"
			@submit="$emit('submit', data)"
		></mobile-controls>
	</v-sheet>
</template>

<script>
import Questions from "@c/survey/render/Questions.vue";
import MobileControls from "@c/survey/render/MobileControls.vue";
import RenderContent from "@c/ui/RenderContent.vue";
export default {
	name: "MobileSurvey",
	data: () => {
		return {
			error: false,
			data: {},
			window: 0,
		};
	},
	props: {
		disable: {type: Boolean}
	},
	components: {
		RenderContent,
		Questions,
		MobileControls,
	},
	computed: {
		windowOrder() {
			let order = ["intro"];
			order = order.concat(this.visibleQuestions);
			return order;
		},
		visibleQuestions() {
			return this.getVisibleQuestions(this.data);
		},
	},
	inject: [
		"isMobile",
		"survey",
		"showIdentity",
		"noQuestions",
		"response",
		"questions",
		"getVisibleQuestions",
		"isAnswered",
	],
	watch: {
		response(value) {
			if (value) {
				this.data = value.data;
			}
		},
	},
};
</script>
